import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "upload-retry-card-filename" }
const _hoisted_2 = { class: "upload-retry-card-error" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "upload-retry-card-contact"
}

import { RETRY_LIMIT } from '../../assets/constants';

export default /*@__PURE__*/_defineComponent({
  __name: 'RetryCard',
  props: {
  fileName: {
    type: String,
    required: true,
  },
  errorMessage: {
    type: String,
    required: true,
  },
  totalFileSize: {
    type: String,
  },
  progressBytes: {
    type: String,
  },
  retryCount: {
    type: Number,
    default: 0,
  }
},
  emits: ["retryUpload", "cancel"],
  setup(__props, { emit: __emit }) {

const ErrorOutline = require("../../assets/images/ErrorOutlineRed.svg") as string;


const props = __props

const emit = __emit

function onCancel() {
  emit("cancel");
}

function onClickRetry() {
  emit("retryUpload");
}


return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["upload-retry-card", props.retryCount > _unref(RETRY_LIMIT) ? 'upload-retry-card-contact-height' : ''])
  }, {
    title: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "upload-retry-card-title" }, " File upload failed ", -1)
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(props.fileName), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _unref(ErrorOutline) }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", null, _toDisplayString("Error: " + props.errorMessage), 1)
      ]),
      (props.retryCount > _unref(RETRY_LIMIT))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString("Please contact support if you are experiencing continuous upload issues")))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", { class: "upload-retry-card-buttons" }, [
        _createElementVNode("button", {
          class: "upload-retry-card-buttons-button",
          onClick: onCancel
        }, " Cancel "),
        _createElementVNode("button", {
          class: "upload-retry-card-buttons-button upload-retry-card-buttons-retry",
          onClick: onClickRetry
        }, " Retry ")
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})